import React from "react";

export const Configuration = () => <></>;
